import * as C from '../common/constants';
import AnimationConfiguration from './AnimationConfiguration';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import { useSelector, useDispatch } from 'react-redux';
import { useState, useEffect } from 'react';
import { useTranslations } from '../common/hooks/useTranslations';
import { useProgress } from '@react-three/drei';
import MenuIcon from '@mui/icons-material/Menu';
import SettingsIcon from '@mui/icons-material/Settings';
import { storeData } from '../common/app/actions';
import { ESides } from '../common/enums';

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      leftStyle: {
        position: 'absolute',
        // width: '100%',
        left: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'flex-start',
      },
      rightStyle: {
        position: 'absolute',
        // width: '100%',
        right: 0,
        top: 0,
        display: 'flex',
        justifyContent: 'flex-start',
      },
      iconStyle: {
        padding: '10px',
        pointerEvents: 'auto',
        color: COLORS.white,
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: 0.7,
            transition: '0.5s ease',
          },
        },
      },
    })
);

const Adjustments = (): JSX.Element => {
  const classes = useStyles();
  const dispatch: any = useDispatch();

  const { active, progress, errors, item, loaded, total } = useProgress();

  // useEffect(() => {
  //   dispatch(storeData(true, C.SET_ROTATION));
  //   dispatch(storeData(true, C.SET_PROPELLER));
  //   dispatch(storeData(true, C.SET_PLATFORM));
  // }, []);

  if (!loaded) {
    return null;
  }

  const onClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    event.stopPropagation();

    const menuSide = event.currentTarget.getAttribute('data-side');

    dispatch(storeData(menuSide, C.SET_MENU));
  };

  return (
    <>
      <div className={classes.leftStyle}>
        <MenuIcon
          onClick={onClick}
          fontSize={'large'}
          className={classes.iconStyle}
          data-side={ESides.LEFT}
        />
        {/* <SettingsIcon
        onClick={onClick}
        fontSize={'large'}
        className={classes.iconStyle}
        data-side={ESides.RIGHT}
      /> */}
      </div>
      <div className={classes.rightStyle}>
        <AnimationConfiguration />
      </div>
    </>
  );
};

export default Adjustments;
